import { Vendor } from '@/types/resources/vendor';
import dayjs from 'dayjs';

const WORKSPACE_ID = 'demo-workspace';
const createWorkspaceRef = () => ({
  id: WORKSPACE_ID,
  name: 'Sunset Gardens',
  slug: 'demo-workspace',
});

const categories = ['Plumbing', 'Electrical', 'Landscaping', 'Catering', 'Security Services', 'IT Support', 'Pest Control', 'Waste Management'];
const companyNames = [
  'Apex Solutions', 'Stellar Services', 'Innovate Inc.', 'Quantum Leap Co.', 'Vertex Group',
  'Pinnacle Providers', 'Synergy Systems', 'Blue-Ribbon Contractors', 'Zenith Works', 'Fusion Enterprises',
  'Evergreen Electricals', 'AquaFlow Plumbers', 'GreenScape Landscaping', 'Gourmet Catering Co.', 'Fortress Security',
  'TechGenius IT', 'BugBusters Pest Control', 'EcoClean Waste Mgmt', 'Pro-Tech Maintenance', 'Reliable Repairs'
];

export const vendors: Vendor[] = Array.from({ length: 50 }, (_, idx) => {
  const companyName = companyNames[idx % companyNames.length];
  const category = categories[idx % categories.length];
  
  return {
    id: `VEND-${(idx + 1).toString().padStart(3, '0')}`,
    type: 'service_provider',
    status: idx % 10 === 0 ? 'inactive' : 'active',
    name: `${companyName} #${idx + 1}`,
    contactPerson: `Contact Person ${idx + 1}`,
    category: category,
    email: `contact.person.${idx + 1}@${companyName.toLowerCase().replace(/ /g, '')}.com`,
    phone: `+1-555-0200-${idx}`,
    address: `${100 + idx} Business Park, Suite 100, Demo City`,
    services: [category],
    paymentTerms: 'net30',
    workspace: createWorkspaceRef(),
    activityRecords: [{
      timestamp: dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate(),
      type: 'created',
      performedBy: { id: 'admin-001', displayName: 'Property Manager' }
    }]
  };
}); 